import React from 'react';
import { useDisclosure } from '@src/core/hooks';
import { EMPTY_STRING } from '@src/core/config';
import { WeatherContext } from '@src/core/socket';
import { arcTemperature, arcVelocitas } from '@src/core/extensions';
import { ArcCellInfo, ArcCollapse, ArcStack, ArcText } from '@src/core/ui';
import { useDispatch } from 'react-redux';
import { setWeatherExpanded } from '@src/core/controllers/map/redux/actions';

const Weather: React.FC = () => {
  const { open, toggle } = useDisclosure();
  const dispatch = useDispatch();
  const { data } = React.useContext(WeatherContext);

  React.useEffect(() => {
    dispatch(setWeatherExpanded(open));
  }, [open, dispatch]);

  if (!data) return null;

  const sys = data?.sys ?? {};
  const main = data?.main ?? {};
  const wind = data?.wind ?? {};
  const clouds = data?.clouds ?? {};
  
  const [ weather ] = data.weather ?? [];

  return (
    <ArcStack>
      <ArcStack
        pl={2}
        pr={1}
        direction='row' 
        borderRadius={2}
        alignItems='center' 
        justifyContent='center'
        bgcolor='background.paper'
        sx={{ cursor: 'pointer' }}
        onClick={toggle}>
        <ArcText.h5> {arcTemperature(main?.temp)} </ArcText.h5>
        <ArcStack width={50} height={50}>
          <img src={`https://openweathermap.org/img/wn/${weather?.icon}@2x.png`} />
        </ArcStack>
      </ArcStack>
      <ArcCollapse in={open}>
        <ArcStack py={2} px={4} spacing={2} mt={1} maxWidth={open ? 300: 100} borderRadius={2} bgcolor='background.paper'>
          <ArcStack spacing={4} direction='row' justifyContent='space-between'>
            <ArcCellInfo label='COUNTRY'>
              {sys?.country ?? EMPTY_STRING}
            </ArcCellInfo>
            <ArcCellInfo label='CLOUDS'>
              {clouds?.all ?? EMPTY_STRING}%
            </ArcCellInfo>
          </ArcStack>

          <ArcStack spacing={4} direction='row' justifyContent='space-between'>
            <ArcCellInfo label='HUMIDITY'>
              {main?.humidity ?? EMPTY_STRING}%
            </ArcCellInfo>

            <ArcCellInfo label='PRESSURE'>
              {main?.pressure ?? EMPTY_STRING}hPa
            </ArcCellInfo>
          </ArcStack>

          <ArcStack spacing={4} direction='row' justifyContent='space-between'>
            <ArcCellInfo label='WIND DIRECTION'>
              {wind?.deg ?? EMPTY_STRING}°
            </ArcCellInfo>

            <ArcCellInfo label='WIND SPEED'>
              {arcVelocitas(wind?.speed)}
            </ArcCellInfo>
          </ArcStack>

        </ArcStack>
      </ArcCollapse>
    </ArcStack>
  );
};


export default Weather;